import { put, select, take } from 'redux-saga/effects';

import { DELETE_HIGHLIGHT, SELECT_HIGHLIGHT, UPDATE_HIGHLIGHT } from './actions';
import { SAVE_SELECTEDHIGHLIGHT } from 'Reducers/dataModels';


function* highlightColorSelected(marker, selectedHighlight) {
  const { id:selHighlightId, markerId:selMarkerId } = selectedHighlight;
  const markerId = marker.id;

  //ignore
  if (!selHighlightId && (markerId === selMarkerId)) {
    return;
  }

  //save highlight
  if (!selHighlightId && (markerId !== selMarkerId)) {
    const newSelectedHighlight = {
      ...selectedHighlight,
      color: marker.color,
      darkColor: marker.darkColor,
      label: marker.label,
      markerId: marker.id
    };

    return yield put({ type: SAVE_SELECTEDHIGHLIGHT, data: newSelectedHighlight });
  }

  //update highlight
  if (selHighlightId && (markerId !== selMarkerId)) {
    return yield put({ type: UPDATE_HIGHLIGHT, data: { markerId, selectedHighlight } });
  }

  //delete highlight
  if (selHighlightId && (markerId === selMarkerId)) {
    return yield put({ type: DELETE_HIGHLIGHT, data: selHighlightId });
  }
}

function* select_() {
  while (true) {
    const { data:{ markerId, selectedHighlight } } = yield take(SELECT_HIGHLIGHT);

    const markers = yield select(state => state.markers);

    const marker = markers.find(_marker => {
      return _marker.id === markerId;
    });

    yield highlightColorSelected(marker, selectedHighlight);
  }
}


export default select_;
